<template>
  <div style="padding:0 0 16px 0">
    <Record v-if="record.id" :record="record" @cancel="record = {}" />
    <div v-else >
      <a-row>
          <div style="display: flex;align-items: center">
            <a-col :span="16">
               <div class="form-group-list">
                    <SelectField label="管网" id="type" style="width: 35%"
                                 :modelValue="form.category" :options="typeList"
                                 @update:modelValue="(value) => handleModelValueUpdate('category', value)"
                    />
                    <InputField style="width:30%;" label="编号" type="text" id="name" labelWidth="30%"
                                :modelValue="form.code" placeholder="请输入编号"
                                @update:modelValue="(value) => handleModelValueUpdate('code', value)"
                    />
                  <a-space>
                      <ButtonField text="查询" @click="query" secondary/>
                      <ButtonField text="重置" primary @click="reset"/>
                  </a-space>
               </div>
            </a-col>

        <a-col :span="8">
          <div class="right" style="margin-top: 4px">
            <a-space>
              <ImportExcel category="pipe" @refresh="reset" />
              <ButtonField text="下载模版" @click="download" secondary />
              <ButtonField text="新增" primary @click="setView('新增管网')"/>
            </a-space>
          </div>
        </a-col>
          </div>
      </a-row>

      <div style="padding-top: 16px"></div>
        <Tablelist
                :showCheckbox="false"
                :list="list"
                :columns="tableColumns"
                :totalSize="totalSize"
                :totalPages="totalPages"
                :pageNum="pageNum"
                :pageSize="pageSize"
                @page-change="onChange"
        >
            <template #template-category="{ item }">
                <DataDictFinder dictType="pipeType" :dictValue="item.category" />
            </template>
            <template v-slot:actions="{ item }">
                <a-space>
                    <a @click.prevent="setRecord(item)">维保记录</a>
                    <a @click.prevent="edit(item)">编辑</a>
                    <a class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
      <div v-if="list.length === 0" style="padding-bottom: 16px"></div>
    </div>
  </div>
</template>
<script>
import store from "../mixins/store";
import ImportExcel from "../components/ImportExcel";
import Record from "./record.vue";

import { fetchList, del } from "@/api/assets/pipe";
import { mapGetters } from "vuex";

export default {
  mixins: [store],
  components: {
    ImportExcel,Record
  },
  data() {
    return {
      form: {},
      list: [],
      loading: false,
      totalSize: 1,
      totalPages: 1,
      pageNum: 1,
      pageSize: 10,
      record: {},
      tableColumns:[
          {
              key: 'code',
              title: '编号',
              field: 'code',
              infotype: 'text',
              width: '180px'
          },
          {
              key: 'category',
              title: '所属管网',
              field: 'category',
              infotype: 'template',
              width: '100px'
          },
          {
              key: 'buringDepthFrom',
              title: '起点埋深(m)',
              field: 'buringDepthFrom',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'elevationFrom',
              title: '起点高程(m)',
              field: 'elevationFrom',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'buringDepthTo',
              title: '终点埋深(m)',
              field: 'buringDepthTo',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'elevationTo',
              title: '终点高程(m)',
              field: 'elevationTo',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'length',
              title: '管长(m)',
              field: 'length',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'diameter',
              title: '管径(mm)',
              field: 'diameter',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'pointFrom',
              title: '上游井编码',
              field: 'pointFrom',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'pointTo',
              title: '下游井编码',
              field: 'pointTo',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'material',
              title: '材质',
              field: 'material',
              infotype: 'text',
              width: '100px'
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template',
              width: '200px',
              fixed: 'right',
          }
      ]
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("pipeType");
    },
  },
  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
    download() {
      window.open(
        "https://qiniu.njszy.com/iot/production/template/%E7%AE%A1%E9%81%93%E8%A1%A8-%E6%A8%A1%E6%9D%BF.xls"
      );
    },

    getList() {
      this.loading = true;
      let { form } = this;

      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.totalSize = res.totalSize;
            this.totalPages = res.totalPages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },

    edit(row) {
      this.setSelectedPipe({
        id: row.id,
        type: row.category,
        category: row.category,
        startLnglat: [row.xfrom, row.yfrom],
        endLnglat: [row.xto, row.yto],
        _change: true,
        _edit: true,
      });
      this.setView("修改管网");
    },

    select(row) {
      this.setSelectedPipe({
        id: row.id,
        type: row.category,
        category: row.category,
        startLnglat: [row.xfrom, row.yfrom],
        endLnglat: [row.xto, row.yto],
        _change: true,
      });
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除该管线吗？",
        onOk() {
          del({
            id: text.id,
            category: text.category,
          }).then(() => {
            that.getList();
            if (text.category === "sewage") {
              that.getSewagePipeList();
            } else {
              that.getRainPipeList();
            }
          });
        },
      });
    },
    setRecord(text) {
      this.record = text;
    },
  },
};
</script>
<style scoped>
.form-group-list{
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
}
</style>